import { Component, OnInit } from "@angular/core";
import { FormsModule, FormGroup, FormBuilder, Validators, ReactiveFormsModule } from "@angular/forms";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CommonModule } from "@angular/common";
import { ValidCouponModalComponent } from "../valid-coupon/valid-coupon.component";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ToastrService } from "ngx-toastr";
import { environment as env } from "../../../../environments/environment";
import { StorageService } from "../../../shared/services/storage.service";
import { Roles } from "../../../shared/models";
import { CollectionService } from "../../collections/collection.service";

@Component({
  selector: "app-search-coupon",
  standalone: true,
  imports: [TranslateModule, FormsModule, ReactiveFormsModule, CommonModule],
  templateUrl: "./search-coupon.component.html",
  styleUrl: "./search-coupon.component.scss",
})
export class SearchCouponComponent implements OnInit {
  token: string = "";
  linkEvent = "";
  userData: any = {};
  isCouponInvalid = false;
  public validate = false;
  public couponForm: FormGroup = new FormGroup({});

  constructor(private activeModal: NgbActiveModal, private fb: FormBuilder, private toastrService: ToastrService, private translateService: TranslateService, private modalService: NgbModal, private storageService: StorageService, private collectionService: CollectionService) {}

  ngOnInit(): void {
    this.initForm();
    this.linkEvent = `${env.landingUrl}${this.token}`;
    this.userData = this.storageService.getFromLocalOrSessionStorage("user") || {};
  }

  initForm() {
    this.couponForm = this.fb.group({
      couponCode: [
        "",
        [Validators.required, Validators.pattern(/^[A-Za-z0-9]{7}$/)],
      ],
    });
  }

  searchCoupon() {
    const codeControl = this.couponForm.get("couponCode");
    codeControl?.markAsTouched();
    const trimmed = (codeControl?.value ?? "").toString().trim();
    codeControl?.setValue(trimmed, { emitEvent: false });

    if (codeControl?.invalid) {
      return;
    }

    const couponCode = trimmed;

    codeControl?.setErrors(null);
    this.collectionService.checkCoupon(couponCode).subscribe((res: any) => {
      if (!res.success) {
        this.couponForm.get("couponCode")?.setErrors({ invalid: true });
        this.validate = false;
        this.isCouponInvalid = true;
        return;
      } else {
        this.validate = true;
        this.isCouponInvalid = false;
        const body = {
          couponCode: couponCode,
        };
        this.activeModal.close(body);
        const modal = this.modalService.open(ValidCouponModalComponent, {
          centered: true,
          backdrop: "static",
          size: "lg",
        });
        modal.componentInstance.token = this.token;
        modal.componentInstance.couponCode = couponCode;
        modal.componentInstance.userData = res.data;
        modal.result.then((result: any) => {
          
        });
      }
    });
  }

  close() {
    this.activeModal.dismiss();
  }
  copyLink() {
    navigator.clipboard
      .writeText(this.linkEvent)
      .then(() => {
        const successMessage = this.translateService.instant("success.link_copied");
        this.toastrService.success("", successMessage);
        this.close();
      })
      .catch((err) => console.error("Errore nella copia: ", err));
  }

  isAdmin() {
    return this.userData.role === Roles.Admin;
  }
}
